import { subscribeToSubsite as apiSubscribeToSubsite } from 'api/cms';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch } from '..';

// Types

export type SubscribedSubsites = {
  subsiteIds: string[];
};
export type State = SubscribedSubsites;

type AddSubscribedSubsiteAction = {
  type: 'ADD_SUBSCRIBED_SUBSITE';
  subsiteId: string;
};
export type Action = AddSubscribedSubsiteAction;

// Reducer

export function subscribedSubsitesReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    subsiteIds: [],
  },
  action: Action
) {
  switch (action.type) {
    case 'ADD_SUBSCRIBED_SUBSITE': {
      const { subsiteId } = action;
      return { ...state, subsiteIds: [...state.subsiteIds, subsiteId] };
    }

    default:
      return state;
  }
}

// Actions

export const addSubscribedSubsite =
  (subsiteId: string) => (dispatch: Dispatch) =>
    dispatch({
      type: 'ADD_SUBSCRIBED_SUBSITE',
      subsiteId,
    });

export const subscribeToSubsite = (subsiteId: string) => (dispatch: Dispatch) =>
  apiSubscribeToSubsite(subsiteId).then(() => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch<any>(addSubscribedSubsite(subsiteId));
  });
